import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import LoadingView from '../../components/LoadingView';
import gql from 'graphql-tag';
import OtherLeaseDetailPage from './OtherLeaseDetailPage';
import {
  ADD_OTHER_LEASE_ON,
  ADD_OTHER_LEASE_OPERATOR, ADD_OTHER_LEASE_PAYMENT,
  DELETE_OTHER_LEASE, DELETE_OTHER_LEASE_PAYMENT,
  EDIT_OTHER_LEASE,
  GET_OTHER_LEASE,
  REMOVE_OTHER_LEASE_ON,
  REMOVE_OTHER_LEASE_OPERATOR, UPDATE_OTHER_LEASE_PAYMENT,
} from '../../components/otherleases/otherleaseQueries';
import {ADD_ROW_PAYMENT, DELETE_ROW_PAYMENT, UPDATE_ROW_PAYMENT} from "../../components/row/ROWQueries";

const OPERATOR_QUERY = gql`
  query {
    Operator {
      id
      name
    }
  }
`;

const OL_TRACTS_QUERY = gql`
  query {
    Tract(orderBy: id_asc) {
      id
      name
    }
  }
`;

const GetOLFromQuery = (queryResult) => {
  if (!Array.isArray(queryResult) || queryResult.length === 0) {
    return false;
  }

  return queryResult[0];
};

const GetInfoFromQuery = (queryResult) => {
  if (!Array.isArray(queryResult) || queryResult.length === 0) {
    return false;
  }

  return queryResult;
};

const EditOtherLease = ({ modalOpen, setModalOpen, match, history }) => {
  const { data, error, loading } = useQuery(GET_OTHER_LEASE, {
    variables: {
      id: match.params.OtherLeaseID,
    },
  });

  const [EditOL] = useMutation(EDIT_OTHER_LEASE);
  const {
    data: tractsData,
    error: tractsError,
    loading: tractsLoading
  } = useQuery(OL_TRACTS_QUERY);

  const {
    data: operatorData,
    error: operatorError,
    loading: operatorLoading
  } = useQuery(OPERATOR_QUERY);

  // const tractsQuery = useQuery(OL_TRACTS_QUERY);
  // const operatorInfo = useQuery(OPERATOR_QUERY);
  const [deleteOL] = useMutation(DELETE_OTHER_LEASE);
  const [placeLeaseOn] = useMutation(ADD_OTHER_LEASE_ON);
  const [removeLease] = useMutation(REMOVE_OTHER_LEASE_ON);
  const [removeOperator] = useMutation(REMOVE_OTHER_LEASE_OPERATOR);
  const [addOperator] = useMutation(ADD_OTHER_LEASE_OPERATOR);
  const [addOtherLeasePayment] = useMutation(ADD_OTHER_LEASE_PAYMENT);
  const [deleteOtherLeasePayment] = useMutation(DELETE_OTHER_LEASE_PAYMENT);
  const [updateOtherLeasePayment] = useMutation(UPDATE_OTHER_LEASE_PAYMENT);

  const anyError = error || tractsError || operatorError;
  const anyLoading = loading || tractsLoading || operatorLoading;

  if (anyError) {
    return <h1>{anyError.toString()}</h1>;
  } else if (anyLoading) {
    return <LoadingView />;
  }

  // if (error || EditOtherLease.error) {
  //   return <h1>{error.toString()}</h1>;
  // } else if (loading || EditOtherLease.loading) {
  //   return <LoadingView />;
  // }

  const OtherLease = GetOLFromQuery(data.OtherLease) || [];
  const tracts = GetInfoFromQuery(tractsData.Tract) || [];
  const operators = GetInfoFromQuery(operatorData.Operator) || [];

  // const tracts = GetInfoFromQuery(tractsQuery.data.Tract ? tractsQuery.data.Tract : null) || [];
  // const operators = GetInfoFromQuery(operatorInfo.data.Operator ? operatorInfo.data.Operator : null) || [];

  return (
    <div>
      <OtherLeaseDetailPage
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        OtherLease={{...OtherLease}}
        EditOL={EditOL}
        history={history}
        tracts={tracts}
        operators={operators}
        deleteOL={deleteOL}
        placeLeaseOn={placeLeaseOn}
        removeLease={removeLease}
        removeOperator={removeOperator}
        addOperator={addOperator}
        addOtherLeasePayment={addOtherLeasePayment}
        deleteOtherLeasePayment={deleteOtherLeasePayment}
        updateOtherLeasePayment={updateOtherLeasePayment}
      />
    </div>
  );
};

export default EditOtherLease;
